<template>
  <v-layout row wrap>
    <v-flex xs12 sm5>
      <p class="body-2 mb-1">Объекты</p>
      <v-treeview v-model="tree" :items="objects" selected-color="indigo" selectable return-object></v-treeview>
    </v-flex>
    <v-flex xs12 sm1 align-self-center>
      <v-menu offset-y v-if="output">
        <v-btn slot="activator"><v-icon>mdi-arrow-right</v-icon></v-btn>
        <v-list>
          <v-list-tile @click="addObject(0)"><v-list-tile-title>Только выбранные</v-list-tile-title></v-list-tile>
          <v-list-tile @click="addObject(1)"><v-list-tile-title>Суммарная по выбранным</v-list-tile-title></v-list-tile>
        </v-list>
      </v-menu>
      <v-btn v-else @click="addObject(0)"><v-icon>mdi-arrow-right</v-icon></v-btn>
    </v-flex>
    <v-flex xs12 sm6>
      <p class="body-2 mb-1">Результат</p>
      <v-alert v-model="existError" dismissible transition="fade-transition" outline>
        Такая последовательность объектов уже добавлена
      </v-alert>
      <draggable v-model="result" @end="dragObject">
        <div v-for="(item, index) in result" class="objects-flex-container">
          <div class="objects-name-block">
            <v-icon v-if="item.type===1">mdi-sigma</v-icon>
            {{item.name}}
          </div>
          <div class="objects-delete-btn">
            <v-btn small icon @click="deleteObject(index)"><v-icon class="mx-0">mdi-delete</v-icon></v-btn>
          </div>
        </div>
      </draggable>
    </v-flex>
  </v-layout>
</template>

<script>
  import draggable from 'vuedraggable'
  
  export default {
    name : "InputSettings",
  
    components: {
      draggable
    },
    
    props:{
      objects: {
        type: Array,
        required: false,
        default: () => []
      },
      value: {
        type: Array,
        required: false,
        default: () => []
      },
      output: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    
    computed:{
      result:{
        get(){ return this.value },
        set(v){}
      },
    },
    
    data(){
      return {
        tree: [],
        existError: false,
      }
    },
    
    methods: {
      addObject(type){
        if(this.tree.length>0){
          let objects = [], name = '', separator = '';
          this.tree.map( (item, index) => {
            separator = (index===this.tree.length-1) ? '' : ' -> '
            objects.push({
              element_type: item.element_type,
              identified: item.identified,
              object_id: item.id,
            })
            name = name+item.name+separator
          })
          let exist = this.result.some( el => {
            return (this.isEqualArrays(objects, el.objects) && type===el.type)
          })
  
          if(!exist){
            this.result.push({ objects, name, type })
            this.tree = []
          } else {
            this.existError = true
            setTimeout( _ => this.existError = false, 2500)
          }
        }
      },
  
      deleteObject(index){
        this.result.splice(index, 1)
        this.$emit('input', this.result)
      },
  
      dragObject ({oldIndex, newIndex}) {
        const movedItem = this.result.splice(oldIndex, 1)[0]
        this.result.splice(newIndex, 0, movedItem)
        this.$emit('input', this.result)
      },
      
      isEqualArrays(arr1, arr2, key = 'object_id'){
        if(arr1.length!==arr2.length) return false
        return arr1.every(el => {
          return (arr2.findIndex(item => item[key]===el[key])>-1)
        })
      }
    }
  }
</script>

<style scoped>
  .objects-flex-container{
    display: flex;
    margin-left: 10px;
    border-bottom: #dbdbdb 1px solid;
  }
  .objects-name-block{
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
  }
  .objects-delete-btn{
    width: 35px;
    display: flex;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Common/InputSettings.vue